module.exports = __webpack_public_path__ + "img/icon_map_1_on_100.56a48a6c.png";